// extracted by mini-css-extract-plugin
module.exports = {"odds":"_2dcafe6","oddsChanged":"_bf47686"};